// extracted by mini-css-extract-plugin
export default {"addressTitle":"_248BaOqKgnq0UDPgbC40EI","currentAddress":"_1WROTR6dpPZI35nL7lm8Eh","changeAddress":"HC1duOOmSPAZZnYhMLn7z","inputTooltipRight":"_11FvDY2yM2pY92lfFFV0lE"};